import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {CallsConfigurationApiService} from '../../../services/api/settings/advanced/calls/calls-configuration-api.service';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'advanced-calls',
  templateUrl: './advanced-calls.component.html',
  styleUrls: ['./advanced-calls.component.scss']
})
export class AdvancedCallsComponent implements OnInit {

  formNotValid = false;
  minCdrCalls;
  maxCdrCalls;
  readonly minCleanupFrequencyCalls = 1;
  readonly maxCleanupFrequencyCalls = 720;

  readonly minHistoryDays = 1;
  readonly maxHistoryDays = 365;

  callsSettings: any = {};
  canSubmit: boolean;


  isCallsFeatureEnable: boolean;

  constructor(private userPrivilege: UserPrivilegeService,
              private callsConfigurationApiService: CallsConfigurationApiService,  private loaderService: LoaderService,
              private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.canSubmit = this.userPrivilege.isAuthorized();
    this.initialization();
  }

  submit(): void {
    if (this.isCallsFeatureEnable && !this.callsSettings.enabled) {
      const confirmationMessage = 'ARM\'s ability to calculate calls duration for the calls quota will be disabled when CDR calls are turned off';
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '460px',
        data: {
          message: confirmationMessage
        }
      });

      dialogRef.componentInstance.onApply.subscribe(result => {
        this.callsConfigurationApiService.editCallsConfiguration(this.callsSettings).toPromise().then((callsSettings) => {
          this.initData(callsSettings);
          dialogRef.close();
        });
      });
    } else {
      this.callsConfigurationApiService.editCallsConfiguration(this.callsSettings).toPromise().then((callsSettings) => {
        this.initData(callsSettings);
    });
  }
  }

  initialization(): void {
    this.loaderService.showMainContainer();
    this.callsConfigurationApiService.getCallsConfiguration().subscribe(callsSettings => {
      this.initData(callsSettings);
      this.loaderService.hideMainContainer();
    });
  }

  initData(callsSettings): void {
    this.callsSettings = callsSettings;
    this.isCallsFeatureEnable = callsSettings.enabled;
    this.minCdrCalls = callsSettings.sizeLimitForCallsCollections;
    this.maxCdrCalls = callsSettings.maxNumberOfStoredCalls;
  }
}
